import { render, staticRenderFns } from "./Ventas.vue?vue&type=template&id=dd70efe8&scoped=true&"
import script from "./Ventas.vue?vue&type=script&lang=js&"
export * from "./Ventas.vue?vue&type=script&lang=js&"
import style0 from "./Ventas.scss?vue&type=style&index=0&id=dd70efe8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd70efe8",
  null
  
)

export default component.exports